export enum RouteName {
  LOGIN = 'login-page',
  LOGIN_CALLBACK = 'login-callback',
  LOST_PASSWORD = 'lost-password',
  HOME = 'home-page',
  CONNECT = 'connect-page',
  CONNECT_SETTINGS = 'connect-settings-page',
  CONNECT_CLIENT = 'connect-client-page',
  CONNECT_SELECT_MAP_AREA = 'connect-select-map-area',
  CONNECT_COMPLETE = 'connect-complete-page',
  SMARTWATCH_OVERVIEW = 'smartwatch-overview-page',
  ACTIVE_SMARTWATCH_SETTINGS = 'active-smartwatch-settings-page',
  UNCONNECT_NOTE = 'unconnect-note-page',
  UNCONNECT_COMPLETE = 'unconnect-complete-page',
  NOTIFICATION_DETAIL = 'notification-detail-page',
  SETTINGS = 'settings-page',
  NOTIFICATIONS = 'notifications-page',
  ADMIN = 'admin-page',
  ADMIN_CLIENTS = 'admin-clients-page',
  ADMIN_NEW_CLIENT = 'admin-new-client-page',
  ADMIN_EDIT_CLIENT = 'admin-edit-client-page',
  ADMIN_SMARTWATCHES = 'admin-smartwatches-page',
  ADMIN_NEW_SMARTWATCH = 'admin-new-smartwatch-page',
  ADMIN_EDIT_SMARTWATCH = 'admin-edit-smartwatch-page',
  ADMIN_LOCATIONS = 'admin-locations-page',
  ADMIN_NEW_LOCATION = 'admin-new-location-page',
  ADMIN_EDIT_LOCATION = 'admin-edit-location-page',
  ADMIN_EMPLOYEES = 'admin-employees-page',
  ADMIN_EDIT_EMPLOYEE = 'admin-edit-employee-page',
  ADMIN_MELDKAMER_SETTINGS = 'admin-meldkamer-settings-page'
}

export enum Viewport {
  MOBILE = 'mobile',
  TABLET = 'tablet',
  DESKTOP = 'desktop'
}

export enum AppConfig {
  GOOGLE_MAPS_API_KEY = 'AIzaSyBpSQ-WwVyFlUBFK5ilHv6t_nl9dr15lXw',
  API_LOCATIONS_URL = '/locations',
  API_CLIENTS_URL = '/clients',
  API_SMARTWATCHES_URL = '/smartwatches',
  API_WALKS_URL = '/walks',
  API_NOTIFICATIONS_URL = '/notifications',
  API_ENVIRONMENT_CONFIG_URL = '/environmentConfig',
  API_WEBSOCKET_REGISTER_URL = '/register',
  API_WEBSOCKET_NOTIFICATIONS_URL = '/topic/notifications',
  API_EMPLOYEES_URL = '/employees',
  API_MICROSOFT_GRAPH_URL = '/microsoftGraph'
}

export enum Role {
  ZORG_PROFESSIONAL = 'Zorg Professional',
  MELDKAMER_MEDEWERKER = 'Meldkamer Medewerker',
  APP_ADMIN = 'App Admin',
  MILES_BEHEERDER = 'Miles Beheerder'
}
